function isOutOfView(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.bottom < 0 ||
        rect.top > window.innerHeight ||
        rect.right < 0 ||
        rect.left > window.innerWidth
    );
}

(function () {
    function init() {
        const collectionCarousel = document.querySelector('.collection-carousel');
        const progressBar = document.querySelector('.collection-progress');
        const assetContent = document.querySelectorAll('.collection-asset-content');
        const pagination = document.querySelectorAll('.pagination-pages .pagination');
    
        const prevButton = document.getElementById('asset-prev-button');
        const nextButton = document.getElementById('asset-next-button');
        const paginationPrev = document.getElementById('pagination-prev');
        const paginationNext = document.getElementById('pagination-next');
        const paginationDotsPrev = document.getElementById('pagination-dots-prev');
        const paginationDotsNext = document.getElementById('pagination-dots-next');

        if (!collectionCarousel || !progressBar || !prevButton || !nextButton || !paginationPrev || !paginationNext || !paginationDotsPrev || !paginationDotsNext) {
            return;
        }
    
        collectionCarousel.addEventListener('blox-carousel-change', (e) => {
            const totalPages = e.detail.totalPages;
            const currentPage = e.detail.currentPage;
            progressBar.value = currentPage;
    
            // Set active asset content
            assetContent.forEach(content => content.classList.remove('active'));
            document.getElementById(`collection-asset-content-${currentPage - 1}`)?.classList.add('active');
    
            const isMobile = window.innerWidth <= 768;
            const maxVisiblePages = isMobile ? 5 : 10;
            const midSize = maxVisiblePages - 2;
            const half = Math.floor(midSize / 2);
    
            let startPage = 2;
            let endPage = totalPages - 1;
    
            if (totalPages > maxVisiblePages) {
                if (currentPage <= half + 1) {
                    endPage = midSize + 1;
                    paginationDotsPrev.hidden = true;
                    paginationDotsNext.hidden = false;
                } else if (currentPage >= totalPages - half) {
                    startPage = totalPages - midSize;
                    paginationDotsPrev.hidden = false;
                    paginationDotsNext.hidden = true;
                } else {
                    startPage = currentPage - half;
                    endPage = currentPage + half;
                    paginationDotsPrev.hidden = false;
                    paginationDotsNext.hidden = false;
                }
    
                startPage = Math.max(2, startPage);
                endPage = Math.min(totalPages - 1, endPage);
            } else {
                paginationDotsPrev.hidden = true;
                paginationDotsNext.hidden = true;
            }
    
            pagination.forEach(button => {
                const pageNum = parseInt(button.id.replace("pagination-page-", ""), 10);
                const isEdge = pageNum === 1 || pageNum === totalPages;
                const isInRange = pageNum >= startPage && pageNum <= endPage;
    
                button.hidden = !(isEdge || isInRange);
                button.classList.toggle('active', pageNum === currentPage);
            });
    
            // Prev/Next button states
            const atFirstPage = currentPage <= 1;
            const atLastPage = currentPage >= totalPages;
    
            prevButton.variant = atFirstPage ? 'default' : 'primary';
            prevButton.disabled = paginationPrev.disabled = atFirstPage;
            nextButton.disabled = paginationNext.disabled = atLastPage;
    
            // Ellipsis visibility
            if (!paginationDotsPrev.hidden && startPage === 2) {
                paginationDotsPrev.hidden = true;
            }
            if (!paginationDotsNext.hidden && endPage === totalPages - 1) {
                paginationDotsNext.hidden = true;
            }

            // Scroll into view if needed
            if (isOutOfView(collectionCarousel)) {
                collectionCarousel.scrollIntoView();
            }
        });
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
